import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export default function useFuelTypes() {
	const { t: $t } = useI18n()

	const fuelTypesObj = computed(() => ({
		'patrol92': {
			title: $t('Gasoline 92'),
			value: 'patrol92'
		},
		'patrol95': {
			title: $t('Gasoline 95'),
			value: 'patrol95'
		},
		'patrol80': {
			title: $t('Gasoline 80'),
			value: 'patrol80'
		},
		'diesel': {
			title: $t('Diesel'),
			value: 'diesel'
		},
		'gas': {
			title: $t('Gas LPG'),
			value: 'gas'
		},
		'metan': {
			title: $t('Metan'),
			value: 'metan'
		},
}))

	return {
		fuelTypesObj,
		fuelTypes: computed(() => Object.values(fuelTypesObj.value)),
	}
}
